module.exports = __webpack_public_path__ + "img/hion_34.9bd468f6.jpg";